<mat-list disableRipple>
  <mat-list-item
    [@snFadeIn]
    [@snFadeOut]
    *ngFor="let item of items; trackBy: trackBy"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
  >
    <div class="share-item-content">
      <div class="share-item-header">
        <div class="organization-name">
          <mat-icon class="organization-icon">apartment</mat-icon>
          {{ item.sharerOrganization.name }}
        </div>
        <span
          class="share-status-badge"
          [ngClass]="item.isAccepted ? 'status-active' : 'status-pending'"
        >
          {{ (item.isAccepted ? 'common.active' : 'common.pending') | t }}
        </span>
      </div>

      <div class="share-item-details">
        <div class="share-date">
          <mat-icon class="share-date-icon">calendar_month</mat-icon>
          {{ 'common.shared' | t }} {{ item.createdAt | date: 'MMM d, y' }}
        </div>

        <div class="access-dates" *ngIf="hasAccessDates(item)">
          <mat-icon class="share-schedule-icon">schedule</mat-icon>
          <span>
            <ng-container *ngIf="item.startDate; else endDateOnly">
              {{ 'common.access' | t }}: {{ item.startDate | date: 'MMM d, y, h:mm a' }} - 
              <ng-container *ngIf="item.endDate">
                {{ item.endDate | date: 'MMM d, y, h:mm a' }}
              </ng-container>
            </ng-container>
            <ng-template #endDateOnly>
              <ng-container *ngIf="item.endDate">
                {{ 'common.access' | t }}: - {{ item.endDate | date: 'MMM d, y, h:mm a' }}
              </ng-container>
            </ng-template>
          </span>
        </div>

        <div class="permissions-badges" *ngIf="getActivePermissions(item).length > 0">
          <ng-container *ngIf="getActivePermissions(item) as permissions">
            <div class="permissions-badges" *ngIf="permissions.length > 0">
              <span class="permission-badge" *ngFor="let permission of permissions">
                {{ permission }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="share-item-actions">
        <button mat-button class="action-button" (click)="onEdit(item, $event)">
          <mat-icon>edit_square</mat-icon>
          {{ 'common.edit' | t }}
        </button>
        <button mat-button class="action-button delete-button" (click)="onDelete(item, $event)">
          <mat-icon>delete</mat-icon>
          {{ 'common.revoke' | t }}
        </button>
      </div>
    </div>
  </mat-list-item>
</mat-list>


